import API from "@/api";

export const LoginPlugin = {
  install(Vue, { router }) {
    console.log("Login plugin:::", Vue.prototype, router);

    const showError = (error) => {
      console.error("update or sync source info error:::", error);
      Vue.prototype.$message.error("图片、视频资源将无法展示，推出重新登陆");
    };

    const updateSourceInfo = async () => {
      try {
        const userInfo = localStorage.getItem("userInfo");
        if (Vue.prototype.$sourceInfo || !userInfo) return;
        const r = await API.getSourceList();
        if (r.code !== 200) throw new Error(r.tip);
        syncSourceInfo(r.data);
      } catch (error) {
        showError(error);
      }
    };

    const syncSourceInfo = (info) => {
      info = info || [];
      Vue.prototype.$sourceInfo = info;
      try {
        Vue.prototype.$imgUrls = findUrls(info, "IMAGE");
        Vue.prototype.$vidUrls = findUrls(info, "VID");
        Vue.prototype.$audUrls = findUrls(info, "AUDIO");
        Vue.prototype.$imgUrl = Vue.prototype.$imgUrls[0];
        Vue.prototype.$vidUrl = Vue.prototype.$vidUrls[0];
        Vue.prototype.$audUrl = Vue.prototype.$audUrls[0];
      } catch (error) {
        showError(error);
      }
    };

    const findUrls = (info, key) => {
      return info.find((kv) => kv.type === key).domain.map((v) => v.url);
    };

    Vue.prototype.$syncSourceInfo = syncSourceInfo;

    router.beforeEach(async (to, from, next) => {
      if (to.path != "/" && to.path != "/login" && to.path != "/welcome") {
        await updateSourceInfo();
      }
      return next();
    });
  },
};
